import { render, staticRenderFns } from "./ckhcDetail.vue?vue&type=template&id=de250ea2&scoped=true&"
import script from "./ckhcDetail.vue?vue&type=script&lang=js&"
export * from "./ckhcDetail.vue?vue&type=script&lang=js&"
import style0 from "./ckhcDetail.vue?vue&type=style&index=0&id=de250ea2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de250ea2",
  null
  
)

export default component.exports